import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Placeholder from '../Placeholder/index.js';
import Typography from '../Typography/index.js';
import { Brandy as Brandy$1 } from './Brandy.styles.js';

var _excluded = ["symbol", "text", "variant", "modal", "content", "disclaimer"];
function RenderText(_ref) {
  var text = _ref.text;
  if (!text) return null;
  if (Array.isArray(text)) return text; // Directly return an array of React elements
  if (/*#__PURE__*/React__default.isValidElement(text)) return text; // Render as-is if it's a React element
  // Otherwise, assume it's a string and render as HTML
  // eslint-disable-next-line react/no-danger
  return /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
}
function RenderSymbol(_ref2) {
  var symbol = _ref2.symbol;
  if (!symbol) return null;
  return /*#__PURE__*/React__default.createElement("span", {
    // Has to be done because of the possible html tags from brandy
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: "".concat(symbol ? "<sup>".concat(symbol, "</sup>") : '').trim()
    }
  });
}
function Brandy(_ref3) {
  var symbol = _ref3.symbol,
    text = _ref3.text,
    variant = _ref3.variant,
    modal = _ref3.modal,
    content = _ref3.content,
    disclaimer = _ref3.disclaimer,
    props = _objectWithoutProperties(_ref3, _excluded);
  var finalText = (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.text) || disclaimer || text;
  if (!modal && !content && !finalText) {
    return /*#__PURE__*/React__default.createElement(Placeholder, {
      type: "warning"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "small"
    }, "Missing Disclaimer Or Modal"), /*#__PURE__*/React__default.createElement(Typography, null, "The disclaimer or modal can't be rendered here. It is most likely a combination of incorrect brand token & brandy reference inside Contentful", /*#__PURE__*/React__default.createElement("i", null, "sites/src/gatsby-config"), "."));
  }
  return /*#__PURE__*/React__default.createElement(Brandy$1, _extends({}, props, {
    className: "leshen-brandy",
    variant: variant || 'legal'
  }), /*#__PURE__*/React__default.createElement(RenderText, {
    text: finalText
  }), /*#__PURE__*/React__default.createElement(RenderSymbol, {
    symbol: symbol
  }), !finalText && content, modal);
}

export { Brandy as default };
//# sourceMappingURL=index.js.map
